// 向admin/service/admin/power/check 传入route，确定按钮是否能使用

// that.$canBtn( that.route).then( function(res_c){
//     console.log(res)
// })

import axios from 'axios' 

import store from '../store'
import alert from  './messageInfo.js'

const canBtn = (route) => {
  return new Promise((resolve, reject) => {
    
  
    //这里可以在调用的时候看到你的method、url、data、headers等参数
    //console.log(newOptions);
    axios({
      method: 'get',
      url: 'admin/service/admin/power/check?route='+route,
      data: {},
      headers: {'content-Type': 'application/json;charset=UTF-8','Authorization':'Bearer '+ store.state.token}
    }).then(res => {
      //根据返回的状态码判断，注意res返回的并不一定都是status，比如小程序就是statusCode
      if (res.status == 200) {
        
       
        if( res.data.code != 1){
            alert.info(res);
            return;
        }
        
        //这里我们只需要获取返回的data中的数据即可
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      reject(err);
    })
  })
};

export default canBtn